var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13 16.31H.95a.56.56 0 0 1-.39-.56v-.56a10.69 10.69 0 0 1 9-10.55V2.24a.56.56 0 0 1 .9-.45l6.75 5.06a.56.56 0 0 1 0 .9l-6.75 5.06a.56.56 0 0 1-.9-.45v-2.1a10.5 10.5 0 0 0-6.79 4.17l-1.19 1.64a.56.56 0 0 1-.45.23Zm9.56-12.93v1.75a.56.56 0 0 1-.5.56 9.56 9.56 0 0 0-8.44 8.21l.09-.11a11.63 11.63 0 0 1 8.23-4.73.56.56 0 0 1 .57.34c.03.07.05.15.05.22v1.63l5.25-3.94-5.25-3.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharemedium);
export default __webpack_public_path__ + "static/media/share.medium.7887b59b304eecf311dd190fc7a7ea05.svg";
export { ForwardRef as ReactComponent };